const g = 9.81;

export function rigidAccelerations(
  m1: number, m2: number, L1: number, L2: number,
  theta1: number, omega1: number, theta2: number, omega2: number,
): [number, number] {
  const delta = theta1 - theta2;
  const sinDelta = Math.sin(delta);
  const cosDelta = Math.cos(delta);
  const denom = m1 + m2 * sinDelta * sinDelta;

  const num1 = -m2 * L1 * omega1 * omega1 * sinDelta * cosDelta
             - m2 * L2 * omega2 * omega2 * sinDelta
             - (m1 + m2) * g * Math.sin(theta1)
             + m2 * g * Math.sin(theta2) * cosDelta;

  const num2 = (m1 + m2) * L1 * omega1 * omega1 * sinDelta
             + m2 * L2 * omega2 * omega2 * sinDelta * cosDelta
             + (m1 + m2) * g * Math.sin(theta1) * cosDelta
             - (m1 + m2) * g * Math.sin(theta2);

  return [num1 / (L1 * denom), num2 / (L2 * denom)];
}

export interface RigidState {
  theta1: number; omega1: number; theta2: number; omega2: number;
}

export function rigidStepVerlet(
  state: RigidState,
  dt: number,
  m1: number, m2: number, L1: number, L2: number,
): RigidState {
  const acc = rigidAccelerations(m1, m2, L1, L2, state.theta1, state.omega1, state.theta2, state.omega2);
  const om1h = state.omega1 + 0.5 * dt * acc[0];
  const om2h = state.omega2 + 0.5 * dt * acc[1];
  const t1n = state.theta1 + dt * om1h;
  const t2n = state.theta2 + dt * om2h;
  const accN = rigidAccelerations(m1, m2, L1, L2, t1n, om1h, t2n, om2h);
  return {
    theta1: t1n,
    omega1: om1h + 0.5 * dt * accN[0],
    theta2: t2n,
    omega2: om2h + 0.5 * dt * accN[1],
  };
}
